import { z } from 'zod';
export const auditListRequest = z.object({
    entitiesList: z
        .array(z.object({
        entity: z.string(),
        entityIds: z.array(z.string().uuid().optional()),
    }))
        .optional(),
    userId: z.string().uuid().optional(),
    user: z.string().optional(),
    eventTypes: z.array(z.string()).optional(),
    timestampFrom: z.number(),
    timestampTo: z.number(),
    includeRelatedEntities: z.boolean().optional(),
    auditTags: z.array(z.string()).optional(),
    limit: z.number().optional(),
    offset: z.number().optional(),
    orderByTimestampDesc: z.boolean().optional(),
});
export const auditListResponse = z.object({
    total: z.number(),
    rows: z.array(z.object({
        id: z.string().uuid(),
        userId: z.string().uuid(),
        userName: z.string(),
        originUserId: z.string().uuid().optional(),
        originUserName: z.string().optional(),
        eventType: z.string(),
        entityName: z.string().optional(),
        entityId: z.string().uuid().optional(),
        timestamp: z.number(),
        transactionId: z.string().uuid().optional(),
        description: z.string().optional(),
        relatedEntityIds: z.array(z.string().uuid()).optional(),
    })),
});
